import { createReducer } from "@reduxjs/toolkit";
import { isLocalStorageEntry, setLocalStorageItemKey } from "common/utilities/browser/localStorage/localStorage";
import { newItem } from "core/redux/actions/localStorage/localStorageActions";
import { clearLocalStorageSelection } from "dataAnalyzer/redux/actions/dataAnalyzerActions";

import type { DataAnalyzerState } from "./dataAnalyzerReducer.types";

export type DataAnalyzerSelectionData = {
  sessionId: string;
  clientId: string;
  ids: string[];
}[];

export const LOCAL_STORAGE_DATA_ANALYZER_SELECTION = "DATA_ANALYZER_SELECTION";
setLocalStorageItemKey(LOCAL_STORAGE_DATA_ANALYZER_SELECTION);

const initialState = (): DataAnalyzerState => ({
  localStorageSelection: undefined,
});

const dataAnalyzerReducer = createReducer(initialState(), (builder) =>
  builder

    .addCase(clearLocalStorageSelection, (state) => ({ ...state, localStorageSelection: undefined }))

    // Load selection (propagated by another instance) via localStorage
    .addCase(newItem, (state, action) => {
      const { item } = action.payload;

      if (isLocalStorageEntry<DataAnalyzerSelectionData>(LOCAL_STORAGE_DATA_ANALYZER_SELECTION, item)) {
        return { ...state, localStorageSelection: item.data };
      }
      return { ...state };
    })
);

export default dataAnalyzerReducer;
